import type { ReactNode } from 'react'
import { createContext, useContext } from 'react'

type ButtonSize = 'default' | 'compact'

type AuthCardContextType = {
  buttonSize: ButtonSize
}

const AuthCardContext = createContext<AuthCardContextType | undefined>(undefined)

export function AuthCardProvider({
  buttonSize,
  children,
}: {
  buttonSize: ButtonSize
  children: ReactNode
}) {
  return (
    <AuthCardContext.Provider value={{ buttonSize }}>
      {children}
    </AuthCardContext.Provider>
  )
}

export function useAuthCardContext() {
  const context = useContext(AuthCardContext)
  return context || { buttonSize: 'default' }
}
